<template>
  <div class="my-lessons">
    <div class="headerSec f_c_b">
      <div class="f_s_s f-d-c">
        <div class="f_c_s">
          <span v-if="categoriesData.has_today_jobrani_session" class="jobrani-badge"> جبرانی </span>
        <h6 class="p-0">{{ categoriesData.name }}</h6>
      </div>
        <breadcrumbs :breadcrumbsData="[breadcrumbsPath.paths[0],breadcrumbsPath.paths[1]]"></breadcrumbs>
      </div>
      <div class="return f_c_e" @click="returnFunc()">
        بازگشت
        <div class="blackarrow myleft"></div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="calendarBox f_s_b col-12">
      <h6 v-if="categoriesData.section.length">{{ categoriesData.name }}</h6>
      <div
        v-if="categoriesData.section.length && !isShowActivities"
        class="calendar f_s_s w-100 f-w-w"
      >
        <div
          v-for="(v, i) in categoriesData.section"
          :key="i"
          class="sectionBox f_c_c f-d-c"
          :id="v.id"
          @click.prevent="categoriesShowFunc(v)"
        >
          <b-img
            :src="require(`@/assets/images/my/lessons/openBook.svg`)"
            fluid
          ></b-img>
          <div class="text">{{ v.name }}</div>
        </div>
        <div
          v-if="categoriesData.activities_in_section.length"
          class="sectionBox f_c_c f-d-c"
          @click.prevent="showActivitiesFunc()"
        >
          <b-img
            :src="require(`@/assets/images/my/lessons/openBook.svg`)"
            fluid
          ></b-img>
          <div class="text sectionActivities">فعالیت های این بخش</div>
        </div>
      </div>
      <CategoriesActivities
        :categoriesData="categoriesData"
        :basicData="{ saveId: saveId, stepIndex: stepIndex }"
      />
      <!-- <CategoriesActivities
        v-if="
          (categoriesData.section.length == 0 &&
            categoriesData.activities_in_section.length) ||
          isShowActivities
        "
        :categoriesData="categoriesData"
        :basicData="{ saveId: saveId, stepIndex: stepIndex }"
      /> -->
      <!-- <div v-if="emptyCategories" class="emptyCategories w-100 h-100 f_c_c">
         فعالیتی وجود ندارد.
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CategoriesActivities from "@/views/my/CategoriesActivities.vue";
import breadcrumbs from "@/components/Breadcrumbs";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "Categories",
  data() {
    return {
      stepIndex: 0,
      saveId: [],
      returnStatus: false,
      emptyCategories: false,
      isShowActivities: false,
    };
  },
  created() {},
  computed: {
    ...mapState({
      loginStates: (state) => state.login,
      heightWidthValue: (state) => state.login.heightWidthValue,
      categoriesData: (state) => state.my.categoriesData,
      categoriesBasicData: (state) => state.my.categoriesBasicData,
      breadcrumbsPath: (state) => state.my.breadcrumbsPath,
      ContentData: (state) => state.my.contentData,
      publicCoursesReturnStatusData: (state) =>
        state.my.publicCoursesReturnStatusData,
    }),
    user() {
      return this.loginStates.user;
    },
  },
  components: { CategoriesActivities,breadcrumbs },
  props: {},
  methods: {
    ...mapActions("my", [
      "prevUrlFunction",
      "showCategoriesFunction",
      "setCategoriesContentFunction",
      "setCategoriesBasicDataFunction",
      "showContentLessonDataFunction",
      "publicCoursesReturnStatusFunction",
    ]),
    getLessonFunc() {
      this.getLessonForumFunction({ wstoken: this.user.token });
    },
    showActivitiesFunc() {
      this.isShowActivities = true;
      this.returnStatus = false;
      this.stepIndex = this.stepIndex + 1;
      this.saveId.push(this.categoriesData.id);
      this.setCategoriesContentFunction(this.categoriesData.section_id);
      this.setCategoriesBasicDataFunction({
        saveId: this.saveId,
        stepIndex: this.stepIndex,
      });
    },
    returnFunc() {
      this.isShowActivities = false;
      this.setCategoriesBasicDataFunction({});
      if (this.publicCoursesReturnStatusData) {
        this.returnStatus = false;
        this.publicCoursesReturnStatusFunction(false);
        this.$router.push({ name: "publicMeet" });
      } else {
        if (this.stepIndex > 1) {
          this.returnStatus = true;
          this.showCategoriesFunction({
            wstoken: this.user.token,
            courseid: this.categoriesData.id,
            section: this.saveId[this.stepIndex - 2],
          });
        } else if (this.stepIndex == 1) {
          this.returnStatus = true;
          this.showCategoriesFunction({
            wstoken: this.user.token,
            courseid: this.categoriesData.id,
            section: 0,
          });
        } else {
          this.returnStatus = false;
          this.$router.push({ name: "lessons" });
        }
      }
    },
    categoriesShowFunc(v) {
      this.returnStatus = false;
      this.stepIndex = this.stepIndex + 1;
      this.saveId.push(v.id);
      this.showCategoriesFunction({
        wstoken: this.user.token,
        courseid: this.categoriesData.id,
        section: v.id,
      });
    },
  },
  watch: {
    categoriesData(n) {
      this.isShowActivities = false;
      if (n.activities_in_section.length == 0 && n.section.length == 0) {
        this.setCategoriesContentFunction(this.categoriesData.section_id);
        this.setCategoriesBasicDataFunction({
          saveId: this.saveId,
          stepIndex: this.stepIndex,
        });
        this.showContentLessonDataFunction({
          v: this.ContentData.v,
          lesson: this.ContentData.lesson,
        });
      }
      if (this.returnStatus) {
        this.stepIndex = this.stepIndex - 1;
        this.saveId.splice(this.stepIndex, 1);
      }
      // this.emptyCategories = false;
    },
  },
  mounted() {
    this.setHeight(this.heightWidthValue);
    // if (
    //   this.categoriesData.activities_in_section.length == 0 &&
    //   this.categoriesData.section.length == 0
    // ) {
    //   this.emptyCategories = true;
    // }
    if (
      Object.keys(this.categoriesBasicData).length &&
      this.categoriesBasicData.saveId.length > 0
    ) {
      this.saveId = this.categoriesBasicData.saveId;
      this.stepIndex = this.categoriesBasicData.stepIndex;
      this.returnFunc();
    }
  },
  beforeDestroy: function () {
    this.prevUrlFunction("categories");
  },
};
</script>

<style lang="scss" scoped>
.my-lessons {
  height: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 0.2rem 1rem;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .headerSec {
    width: 100%;
    padding: 0 10px;
    h6 {
      padding: 10px 10px 0 0;
      margin: 0;
      font-size: 14px;
    }
    .return {
      cursor: pointer;
      color: #707070;
      font-size: 12px;
      div {
        margin: 0 3px 0 0;
      }
    }
  }
  .calendarBox {
    padding: 0 10px;
    height: 80%;
    flex-direction: column;
    .emptyCategories {
      font-weight: bold;
      font-size: 2rem;
      color: #1d9dae;
    }
    h6 {
      color: #1d9dae;
      font-weight: bold;
    }
    .calendar {
      height: 100%;
      overflow: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .sectionBox {
        color: #006e7f;
        border: 1px solid #006e7f;
        border-radius: 10px;
        cursor: pointer;
        width: 10rem;
        height: 8rem;
        margin-left: 40px;
        margin-bottom: 40px;
        img {
          margin-bottom: 10px;
        }
        .text {
          line-height: 1;
          font-size: 1.25rem;
        }
      }
      .activeBox {
        background-color: #006e7f;
        .text {
          color: white;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .my-lessons {
    .calendarBox {
      flex-direction: column;
      .calendar {
        flex: 0 0 100% !important;
        max-width: 100%;
        .content {
          .activities {
            min-height: 45vh;
          }
        }
      }
      .task-class {
        display: none;
      }
    }
  }
}
@media (max-width: 767px) {
  .my-lessons {
    padding: 0;
    .calendarBox {
      justify-content: flex-start;
      overflow: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .calendar {
        flex: 0 0 100% !important;
        max-width: 100%;
        justify-content: center;
      }
    }
  }
}
</style>